module.exports = __webpack_public_path__ + "img/5.28f56758.png";